import { render, staticRenderFns } from "./TopicMenuSP.vue?vue&type=template&id=7805bf12&scoped=true&"
import script from "./TopicMenuSP.vue?vue&type=script&lang=js&"
export * from "./TopicMenuSP.vue?vue&type=script&lang=js&"
import style0 from "./TopicMenuSP.vue?vue&type=style&index=0&id=7805bf12&prod&lang=scss&scoped=true&"
import style1 from "./TopicMenuSP.vue?vue&type=style&index=1&id=7805bf12&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7805bf12",
  null
  
)

export default component.exports